<template>
  <b-form
    class="chat-app-form customer-chat-composer"
    @submit.prevent="submit"
  >
    <div class="flex-grow-1 mr-1">
      <b-form-textarea
        ref="input"
        v-model="text"
        rows="1"
        max-rows="4"
        no-resize
        :maxlength="maxLength"
        placeholder="Digite sua mensagem (Enter envia, Shift+Enter quebra linha)"
        @keydown.enter.exact.prevent="submit"
        @input="onInput"
      />
      <small
        v-if="remaining <= 300"
        class="text-muted"
      >
        {{ remaining }} caracteres restantes
      </small>
    </div>
    <b-button
      variant="primary"
      type="submit"
      :disabled="!canSubmit"
    >
      Enviar
    </b-button>
  </b-form>
</template>

<script>
import { BForm, BFormTextarea, BButton } from 'bootstrap-vue'
import * as types from '../store/types'

const MAX_LENGTH = 4000

export default {
  components: {
    BForm,
    BFormTextarea,
    BButton,
  },
  props: {
    conversationId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      text: '',
      maxLength: MAX_LENGTH,
    }
  },
  computed: {
    remaining() {
      return MAX_LENGTH - this.text.length
    },
    canSubmit() {
      const trimmed = this.text.trim()
      return trimmed.length > 0 && trimmed.length <= MAX_LENGTH
    },
  },
  watch: {
    conversationId() {
      this.text = ''
    },
  },
  methods: {
    onInput() {
      if (this.text) this.$store.dispatch(types.SEND_TYPING, this.conversationId)
    },
    submit() {
      if (!this.canSubmit) return
      const body = this.text
      // Otimista: limpa já; falhas ficam na bolha com "Reenviar".
      this.text = ''
      this.$store.dispatch(types.SEND_MESSAGE, { conversationId: this.conversationId, body })
      this.$emit('sent')
    },
    focus() {
      if (this.$refs.input) this.$refs.input.focus()
    },
  },
}
</script>
